import { CircularProgress, Flex } from '@chakra-ui/react';

const Spinner = () => (
  <Flex justifyContent="center">
    <CircularProgress isIndeterminate color="gray.600" />
  </Flex>
);

export default Spinner;
